import { t } from '../../../locale/texts';
import type { PpValidationResult, PrepackageSearchState } from '../../types';

export const usePrepackageValidation = (
    state: PrepackageSearchState,
    pristine: boolean,
): PpValidationResult & {
    validationErrors: Partial<Record<'destination' | 'departureDate' | 'returnDate', string | null>>;
} => {
    const hasTyped = !!state.destination?.trim();
    const hasSelected = !!state.destinationId;
    const isFlexible = state.searchType === 'flexible';

    const invalid = {
        destination: !pristine && hasTyped && !hasSelected,
        departureDate: !pristine && !isFlexible && !state.departureDate,
        returnDate: !pristine && !isFlexible && !state.returnDate,
    };

    const validationErrors = {
        destination: invalid.destination ? t('prepackage.validation.destination') : null,
        departureDate: invalid.departureDate ? 'Du må velge dato' : null,
        returnDate: invalid.returnDate ? 'Du må velge dato' : null,
    };

    const validateState = (): boolean => {
        const validDestination = !hasTyped || hasSelected;
        const validFlexibleDeparture = isFlexible;
        const validFixedDeparture = !isFlexible && Boolean(state.departureDate) && Boolean(state.returnDate);
        return validDestination && (validFixedDeparture || validFlexibleDeparture);
    };

    return { validateState, invalid, validationErrors };
};
